<script lang="ts">
  import { scaleLinear } from 'd3-scale';

  let width = 1000;
  let height = 250;
  const margin = { top: 40, right: 0, bottom: 0, left: 0 };

  export let n = 500;
  const xRange = 40;
  const xDomain = [0, 35];

  // Make the scales reactive to size change (i.e width) note the "$" notation
  $: x = scaleLinear()
    .domain(xDomain)
    .range([margin.left, width - margin.right]);

  $: y = scaleLinear()
    .domain([0, 0.15])
    .range([height - margin.bottom, margin.top]);

  const dist = { m: 8, sd: 2.5, color: 'red' };

  const normPDF = (m, sd, x) => {
    const numerator = Math.exp(-Math.pow(x - m, 2) / (2 * Math.pow(sd, 2)));
    const denominator = sd * Math.sqrt(2 * Math.PI);
    return numerator / denominator;
  };

  const createDatum = (i, dist) => {
    const x = xDomain[0] + (xRange * i) / n;
    const y = normPDF(dist.m, dist.sd, x);
    return {
      dist: dist,
      index: i,
      x: x,
      y: y
    };
  };

  let data;

  $: data = new Array(n + 1).fill(0);

  $: data.forEach((datum, i) => {
    data[i] = createDatum(i, dist);
  });
</script>

<div bind:clientWidth={width}>
  <svg viewBox="0 0 {width} 300" {width} height="300px">
    {#if data}
      {#each data as d}
        <circle cx={x(d.x)} cy={y(d.y)} r="1" fill="red" />
      {/each}
    {/if}
  </svg>
</div>
